import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../../services/cuentas-por-cobrar.service';

@Component({
  selector: 'app-modal-ver-contrato',
  templateUrl: './modal-ver-contrato.component.html',
  styleUrls: ['./modal-ver-contrato.component.scss']
})
export class ModalVerContratoComponent implements OnInit {

  @ViewChild('modalVerContrato') private content: TemplateRef<any>;

  modal: any=null;
  contrato: any={
    proveedor:{},
    obligados_solidarios:[{}],
    rentas:[],
    mantenimientos:[],
    servicios: []
  };
  public id_contrato = '';
  public loading: boolean = false;

  constructor(private cuentasPorCobrarService: CuentasPorCobrarService,
              private modalService: NgbModal) { }

  ngOnInit() {
  }

  public openModal(id_contrato){
    this.id_contrato = id_contrato;
    this.loadContrato(this.id_contrato);
  }

  public loadContrato(id_contrato){
    this.loading = true;
    this.cuentasPorCobrarService.recuperarContrato(id_contrato)
    .subscribe(
        (response)=> {
            this.loading = false;
            let content = response.json().content;
            this.contrato = content;
        },
        (error) => {
        this.loading = false;
        }
    );
    this.modal = this.modalService.open(this.content, {size: 'lg'});

  }

  public closeModal() {
    this.modal.close();
    this.id_contrato = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contratos/listado/modal-ver-contrato/modal-ver-contrato.component.ts